import { AuthLayout } from '@app/layouts';
import { SignIn } from '@app/auth/components/SignIn';

export const SignInParentPage = () => {
  return (
    <AuthLayout>
      <SignIn isParent />
    </AuthLayout>
  );
};
